import { render, staticRenderFns } from "./GoFinance.vue?vue&type=template&id=ab1c3b04&scoped=true&"
import script from "./GoFinance.vue?vue&type=script&lang=js&"
export * from "./GoFinance.vue?vue&type=script&lang=js&"
import style0 from "./GoFinance.vue?vue&type=style&index=0&id=ab1c3b04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab1c3b04",
  null
  
)

export default component.exports